// Redux
import { useDispatch } from "react-redux";

// Services
import { ServiceImpl } from "./../../usecase/ServiceImpl";
import { useState } from "react";
import { resetCM0021, setVisibleCM0021 } from "../slice/Slice";

import ErrorNotification from "../../../../../common/components/notification/ErrorNotification";
import MESSAGE, {
  LABEL_MESSAGE,
  NOTIFICATION_TITLE,
  getConfirmDescription,
} from "../../../../../common/constants/MESSAGE";
import SuccessNotification from "../../../../../common/components/notification/SuccessNotification";
import {
  DataState,
  ReSummaryCompanyProjectOutsourceCostRetrievePayload,
  SummaryDataStateType,
} from "../../entity/Entity";
import { getDataWithFormula } from "../../helper";
import ConfirmModal from "../../../../../common/components/modal/ConfirmModal";
import { ItemApprove } from "../../../../../common/components/approval-flow/ApprovalFlow";
import { setModalApproveConfirmDescription, setModalApproveConfirmTitle, showModalApproveConfirm } from "../../../../../common/components/modal-approve-confirm/presenter/slice/Slice";
import { store } from "../../../../../store";
import { resetApproveRejectInfo } from "../../../../../common/components/modal-approve-reject-info/presenter/slice/Slice";
import moment from "moment";

const CM0021Handler = (service: ServiceImpl) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState<boolean>(false);
  const [expandCompanyKey, setExpandCompanyKey] = useState<any[]>([]);
  const [expandProjectKey, setExpandProjectKey] = useState<any[]>([]);
  const [outsourceCompanies, setOutsourceCompanies] = useState<DataState[]>([]);
  const [summaryData, setSummaryData] = useState<SummaryDataStateType>({
    actualCost: 0,
    consumptionTax: 0,
    paymentAmountIncludingTax: 0,
  });
  const [workflow, setWorkflow] = useState<ItemApprove[]>([]);
  const [currentUserApproval, setCurrentUserApproval] =
    useState<ItemApprove | null>(null);

  const getWorkflowSummaryMaterialCompanyApprovalProcess = async (
    documentId: number
  ) => {
    try {
      setLoading(true);
      const data =
        await service.getWorkflowSummaryMaterialCompanyApprovalProcess({
          documentId,
        });
      if (data.results.currentUserApproval)
        setCurrentUserApproval({
          approveDate: data.results.currentUserApproval.approveDate,
          contact_address: "",
          email: data.results.currentUserApproval.email,
          id: data.results.currentUserApproval.id,
          isApprove: data.results.currentUserApproval.approve,
          reject: data.results.currentUserApproval.reject,
          position: "",
          priority: data.results.currentUserApproval.priority,
          username: data.results.currentUserApproval.username,
          fullName: data.results.currentUserApproval.fullName,
          note: data.results.currentUserApproval.note,
        });
      const workflowData: ItemApprove[] = data.results.listApprover.map(
        (element) => {
          let note = element.note;
          if (element.id === data.results?.currentUserApproval?.id)
            note = data.results.currentUserApproval.note;
          const result: ItemApprove = {
            approveDate: element.approveDate,
            contact_address: "",
            email: element.email,
            id: element.id,
            isApprove: element.approve,
            reject: element.reject,
            position: "",
            priority: element.priority,
            username: element.username,
            fullName: element.fullName,
            note: note,
          };
          return result;
        }
      );
      setWorkflow(workflowData);
    } catch (error: any) {
      ErrorNotification(error?.message ?? NOTIFICATION_TITLE.ERROR);
    } finally {
      setLoading(false);
    }
  };

  // call companies

  const getCompanyProjectOurSourceCost = async (params: {
    documentCompanyId: number;
  }) => {
    const projectList =
      await service.getReSummarySubmittedMaterialCostCompanyProject(params);
    const constructionData = await Promise.all(
      projectList.map((element) => {
        return service.getReSummarySubmittedMaterialCostCompanyProjectConstruction(
          {
            documentProjectId: element.id,
          }
        );
      })
    );
    const result = projectList.map((element, index) => {
      const dataConstruction = constructionData[index].sort((a, b: any) => {
        return moment(b.createdAt).diff(a.createdAt);
      });
      return { ...element, constructionList: dataConstruction };
    });
    return result;
  };

  const getInitialData = async (params: { documentId: number }) => {
    try {
      setLoading(true);

      // companies - LV1
      const companyResults =
        await service.getReSummarySubmittedMaterialCostCompany(params);
      // project - LV2
      const projectPromiseAllData = await Promise.all(
        companyResults.map((element) => {
          return getCompanyProjectOurSourceCost({
            documentCompanyId: element.id,
          });
        })
      );

      let materialCostCompanyData: DataState[] = companyResults.map(
        (element: any, index) => {
          return {
            ...element,
            projectList: projectPromiseAllData[index],
          };
        }
      );
      const { data, summary } = getDataWithFormula(materialCostCompanyData);
      if (data.length > 0) {
        setExpandCompanyKey([data[0].id]);
        if (data[0].projectList.length > 0)
          setExpandProjectKey([data[0].projectList[0].id]);
      }
      setSummaryData(summary);
      setOutsourceCompanies(data);
    } catch (error: any) {
      ErrorNotification(error?.message ?? NOTIFICATION_TITLE.ERROR);
    } finally {
      setLoading(false);
    }
  };

  const cancelModalCM0021 = () => {
    dispatch(setVisibleCM0021(false));
    dispatch(resetApproveRejectInfo());
  };

  const setProjectExpandKeys = (key: any) => {
    const checkKey = checkProjectKeyExpand(key);
    if (checkKey) {
      const newExpandKey = expandProjectKey.filter(
        (keyExpand: any) => keyExpand !== key
      );
      setExpandProjectKey(newExpandKey);
    } else {
      setExpandProjectKey([...expandProjectKey, key]);
    }
  };

  const checkProjectKeyExpand = (key: any) => {
    if (!key || !expandProjectKey) return false;
    return expandProjectKey.some((element: any) => element === key);
  };

  const setCompanyExpandKeys = (key: any) => {
    const checkKey = checkCompanyKeyExpand(key);
    if (checkKey) {
      const newExpandKey = expandCompanyKey.filter(
        (keyExpand: any) => keyExpand !== key
      );
      setExpandCompanyKey(newExpandKey);
    } else {
      setExpandCompanyKey([...expandCompanyKey, key]);
    }
  };

  const checkCompanyKeyExpand = (key: any) => {
    if (!key || !expandCompanyKey) return false;
    return expandCompanyKey.some((element: any) => element === key);
  };
  const putReSummaryMaterialCostCompanyRetrieve = async (
    data: ReSummaryCompanyProjectOutsourceCostRetrievePayload,
    afterSuccess?: () => void
  ): Promise<void> => {
    ConfirmModal({
      onOk: async () => {
        try {
          setLoading(true);
          const responseData =
            await service.putReSummaryMaterialCostCompanyRetrieve(data);
          if (responseData) {
            SuccessNotification(
              responseData?.message ?? NOTIFICATION_TITLE.SUCCESS
            );
            dispatch(resetCM0021());
            if (afterSuccess) afterSuccess();
          }
        } catch (error: any) {
          ErrorNotification(error?.message ?? NOTIFICATION_TITLE.ERROR);
        } finally {
          setLoading(false);
        }
      },
      className: "confirm__modal",
      title: MESSAGE.MESSAGE_TITLE_CM016,
      description: "提出中の社内収支の材料費を\n取り下げてもよろしいでしょうか？",
      canceText: LABEL_MESSAGE.CANCEL_MODAL,
      okText: LABEL_MESSAGE.OK_MODAL,
      isCenterWithoutMenu: true,
    });
  };
  const showConfirmApproveModal = () => {
    const fileName = store.getState().approveRejectInfo.fileName;
    dispatch(setModalApproveConfirmTitle(MESSAGE.MESSAGE_TITLE_MODAL_CONFIRM_CM));
    dispatch(setModalApproveConfirmDescription(getConfirmDescription(fileName || undefined)));
    dispatch(showModalApproveConfirm());
  };
  return {
    outsourceCompanies,
    expandProjectKey,
    loading,
    expandCompanyKey,
    summaryData,
    workflow,
    currentUserApproval,
    cancelModalCM0021,
    getInitialData,
    checkProjectKeyExpand,
    setProjectExpandKeys,
    checkCompanyKeyExpand,
    setCompanyExpandKeys,
    putReSummaryMaterialCostCompanyRetrieve,
    getWorkflowSummaryMaterialCompanyApprovalProcess,
    showConfirmApproveModal,
  };
};

export default CM0021Handler;
